import React from 'react';
import SectionHead from './SectionHead';

function Process({ data }) {
  return (
    <section className="section alt">
      <SectionHead title={data.title} copy={data.copy} />
      <div className="process">
        {data.steps.map((step) => (
          <div className="process-step" key={step.step}>
            <span>{step.step}</span>
            <h3>{step.title}</h3>
            <p>{step.copy}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Process;
